// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-config-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}
.email-config-section .email-config-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}
.settings-card.no-config-card {
  text-align: center;
  padding: 3rem 1.5rem;
}
.settings-card.no-config-card .no-config-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.settings-card.no-config-card .no-config-content .no-config-icon {
  color: #9ca3af;
  margin-bottom: 1rem;
}
.settings-card.no-config-card .no-config-content h4 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
.settings-card.no-config-card .no-config-content p {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 2rem;
  max-width: 400px;
}
.settings-card.no-config-card .no-config-content .create-account-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.settings-card.no-config-card .no-config-content .create-account-btn:hover:not(:disabled) {
  background: #003a7a;
  transform: translateY(-1px);
}
.settings-card.no-config-card .no-config-content .create-account-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.2);
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.form-group-email-config {
  margin-bottom: 1rem;
}
.form-group-email-config label {
  display: block;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}
.form-group-email-config input, .form-group-email-config textarea, .form-group-email-config select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
  transition: all 0.3s ease;
}
.form-group-email-config input:focus, .form-group-email-config textarea:focus, .form-group-email-config select:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.form-group-email-config input::placeholder, .form-group-email-config textarea::placeholder, .form-group-email-config select::placeholder {
  color: #94a3b8;
}
.form-group-email-config select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.form-group-email-config .display-value {
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}
.form-group-email-config .display-value.password-mask {
  font-family: monospace;
  letter-spacing: 2px;
  overflow: hidden;
}
.form-group-email-config .display-value.status {
  font-weight: 600;
  text-align: center;
}
.form-group-email-config .display-value.status.enabled {
  color: #059669;
  background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);
  border-color: rgba(5, 150, 105, 0.2);
}
.form-group-email-config .display-value.status.disabled {
  color: #dc2626;
  background: linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);
  border-color: rgba(220, 38, 38, 0.2);
}
.form-group-email-config .change-password-btn {
  background: #f59e0b;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
}
.form-group-email-config .change-password-btn:hover:not(:disabled) {
  background: #d97706;
  transform: translateY(-1px);
}
.form-group-email-config .change-password-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.smtp-info {
  margin-top: 1rem;
  padding: 1rem;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
}
.smtp-info .info-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  color: #3b82f6;
  font-weight: 500;
  font-size: 0.875rem;
}
.smtp-info .info-content {
  font-size: 0.75rem;
  color: #6b7280;
}
.smtp-info .info-content .info-item {
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
}
.smtp-info .info-content .info-item .label {
  font-weight: 500;
  color: #374151;
}
.smtp-info .info-content .info-item .value {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  font-size: 0.6875rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
}

.modal {
  background: #ffffff;
  border-radius: 12px;
  max-width: 600px;
  width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.modal.email-config-modal {
  max-width: 800px;
}
.modal.password-modal {
  max-width: 500px;
}
.modal .modal-header {
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}
.modal .modal-header h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #004A9A;
  margin: 0;
}
.modal .modal-header .close-btn {
  border: none;
  background: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal .modal-header .close-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.modal .modal-header .close-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.modal .modal-body {
  padding: 1.5rem;
  flex: 1 1;
  overflow-y: auto;
}
.modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.modal .modal-footer .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
}
.modal .modal-footer .cancel-btn:hover {
  background: #e2e8f0;
}
.modal .modal-footer .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.modal .modal-footer .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.modal .modal-footer .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
  opacity: 0.6;
}

.step-info {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}
.step-info svg {
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: #3b82f6;
}
.step-info p {
  margin: 0;
  color: #1e40af;
  font-size: 0.95rem;
  line-height: 1.5;
}
.step-info.success {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.step-info.success svg {
  color: #16a34a;
}
.step-info.success p {
  color: #166534;
}

.password-mismatch-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  margin-top: 1rem;
  color: #dc2626;
  font-size: 0.9rem;
}
.password-mismatch-error svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .email-config-section {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons .cancel-btn,
  .action-buttons .save-btn {
    width: 100%;
    justify-content: center;
  }
  .modal {
    margin: 1rem;
    width: calc(100% - 2rem);
  }
  .settings-card {
    padding: 1rem;
  }
  .step-info {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/EmailConfigSettings/EmailConfigSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EAEA,cAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAIA;;EAEE,wBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AADJ;AAIE;EACE,kBAAA;EACA,oBAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,cAAA;EACA,mBAAA;AAFR;AAKM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAMM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAJR;AAOM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AALR;AAOQ;EACE,mBAAA;EACA,2BAAA;AALV;AAQQ;EACE,aAAA;EACA,2CAAA;AANV;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVF;AAYE;EACE,gBAAA;EACA,cAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAXF;AAaE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;AAcI;EACE,2BAAA;AAZN;AAeI;EACE,2BAAA;AAbN;AAiBE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAfN;;AAoBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;AAmBE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAlBN;AAqBI;EACE,cAAA;AAnBN;AAuBE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAtBJ;AAuCI;EACG,sBAAA;EACA,mBAAA;EAID,gBAAA;AAxCN;AA6CI;EACE,gBAAA;EACA,kBAAA;AA3CN;AA6CM;EACE,cAAA;EACA,4FAAA;EACA,oCAAA;AA3CR;AA8CM;EACE,cAAA;EACA,4FAAA;EACA,oCAAA;AA5CR;AAiDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,mBAAA;EACA,2BAAA;AA/CN;AAkDI;EACE,aAAA;EACA,6CAAA;AAhDN;;AAqDA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAlDF;AAoDE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,kBAAA;EACA,cAAA;AAnDJ;AAqDI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAnDN;AAqDM;EACE,gBAAA;EACA,cAAA;AAnDR;AAsDM;EACE,cAAA;EACA,mCAAA;EACA,0BAAA;EACA,kBAAA;EACA,oBAAA;AApDR;;AA0DA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAvDF;AAyDE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAvDJ;AAyDI;EACE,mBAAA;AAvDN;AA2DE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAzDJ;AA2DI;EACE,mBAAA;AAzDN;AA4DI;EACE,mBAAA;EACA,mBAAA;AA1DN;;AAgEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AA7DF;;AAgEA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,gBAAA;AA7DF;AA+DE;EACE,gBAAA;AA7DJ;AAgEE;EACE,gBAAA;AA9DJ;AAiEE;EACE,kCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AA/DJ;AAiEI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/DN;AAkEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhEN;AAkEM;EACE,yBAAA;EACA,cAAA;AAhER;AAmEM;EACE,aAAA;EACA,6CAAA;AAjER;AAsEE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AApEJ;AAuEE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;AArEJ;AAuEI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;AArEN;AAuEM;EACE,mBAAA;AArER;AAyEI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAvEN;AAyEM;EACE,mBAAA;AAvER;AA0EM;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAxER;;AA+EA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AA5EF;AA8EE;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AA5EJ;AA+EE;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA7EJ;AAgFE;EACE,mBAAA;EACA,qBAAA;AA9EJ;AAgFI;EACE,cAAA;AA9EN;AAiFI;EACE,cAAA;AA/EN;;AAqFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAlFF;AAoFE;EACE,cAAA;AAlFJ;;AAuFA;EACE;IACE,aAAA;EApFF;EAuFA;IACE,0BAAA;EArFF;EAwFA;IACE,sBAAA;EAtFF;EAwFE;;IAEE,WAAA;IACA,uBAAA;EAtFJ;EA0FA;IACE,YAAA;IACA,wBAAA;EAxFF;EA2FA;IACE,aAAA;EAzFF;EA4FA;IACE,iBAAA;EA1FF;AACF","sourcesContent":["// EmailConfigSettings.scss - Updated to match InvoiceSettings styling\r\n.email-config-section {\r\n  padding: 2rem;\r\n  background: #f4f6f8;\r\n  // min-height: 100vh;\r\n  color: #334155;\r\n  \r\n  .email-config-title {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 2rem;\r\n    text-align: center;\r\n  }\r\n}\r\n.no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.settings-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #e0e0e0;\r\n  \r\n  .card-title {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 1.2rem;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 1px solid #f1f1f1;\r\n  }\r\n\r\n  &.no-config-card {\r\n    text-align: center;\r\n    padding: 3rem 1.5rem;\r\n\r\n    .no-config-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      gap: 1rem;\r\n\r\n      .no-config-icon {\r\n        color: #9ca3af;\r\n        margin-bottom: 1rem;\r\n      }\r\n\r\n      h4 {\r\n        font-size: 1.3rem;\r\n        font-weight: 600;\r\n        color: #374151;\r\n        margin-bottom: 0.5rem;\r\n      }\r\n\r\n      p {\r\n        font-size: 1rem;\r\n        color: #6b7280;\r\n        margin-bottom: 2rem;\r\n        max-width: 400px;\r\n      }\r\n\r\n      .create-account-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n        padding: 0.75rem 1.5rem;\r\n        background: #004A9A;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 8px;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover:not(:disabled) {\r\n          background: #003a7a;\r\n          transform: translateY(-1px);\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.toggle-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  \r\n  label {\r\n    font-weight: 500;\r\n    color: #475569;\r\n  }\r\n}\r\n\r\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 26px;\r\n  \r\n  input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n    \r\n    &:checked + .toggle-slider {\r\n      background-color: #004A9A;\r\n    }\r\n    \r\n    &:checked + .toggle-slider:before {\r\n      transform: translateX(24px);\r\n    }\r\n    \r\n    &:focus + .toggle-slider {\r\n      box-shadow: 0 0 1px #004A9A;\r\n    }\r\n  }\r\n  \r\n  .toggle-slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #c4c4c4;\r\n    transition: .4s;\r\n    border-radius: 34px;\r\n    \r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 22px;\r\n      width: 22px;\r\n      left: 2px;\r\n      bottom: 2px;\r\n      background-color: white;\r\n      transition: .4s;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.form-group-email-config {\r\n  margin-bottom: 1rem;\r\n  \r\n  label {\r\n    display: block;\r\n    font-weight: 500;\r\n    color: #475569;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  input, textarea, select {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    background: #f9fafb;\r\n    transition: all 0.3s ease;\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3a86ff;\r\n      box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\r\n    }\r\n    \r\n    &::placeholder {\r\n      color: #94a3b8;\r\n    }\r\n  }\r\n  \r\n  select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n    background-position: right 0.5rem center;\r\n    background-repeat: no-repeat;\r\n    background-size: 1.5rem 1.5rem;\r\n    padding-right: 2.5rem;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .display-value {\r\n    padding: 0.75rem;\r\n    background: #f8fafc;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    color: #475569;\r\n    font-size: 0.95rem;\r\n    margin-bottom: 0.5rem;\r\n\r\n    // &.account-type {\r\n    //   text-transform: capitalize;\r\n    //   font-weight: 500;\r\n    //   color: #004A9A;\r\n    //   background: linear-gradient(135deg, rgba(0, 74, 154, 0.1) 0%, rgba(0, 74, 154, 0.05) 100%);\r\n    //   border-color: rgba(0, 74, 154, 0.2);\r\n    // }\r\n\r\n    // &.email-address {\r\n    //   font-family: 'Courier New', monospace;\r\n    //   color: #059669;\r\n    //   background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);\r\n    //   border-color: rgba(5, 150, 105, 0.2);\r\n    // }\r\n\r\n    &.password-mask {\r\n       font-family: monospace;\r\n       letter-spacing: 2px;\r\n      // color: #6b7280;\r\n      // background: #f1f5f9;\r\n      // border-color: #cbd5e1;\r\n      overflow: hidden;\r\n\r\n      \r\n    }\r\n\r\n    &.status {\r\n      font-weight: 600;\r\n      text-align: center;\r\n      \r\n      &.enabled {\r\n        color: #059669;\r\n        background: linear-gradient(135deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);\r\n        border-color: rgba(5, 150, 105, 0.2);\r\n      }\r\n\r\n      &.disabled {\r\n        color: #dc2626;\r\n        background: linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);\r\n        border-color: rgba(220, 38, 38, 0.2);\r\n      }\r\n    }\r\n  }\r\n\r\n  .change-password-btn {\r\n    background: #f59e0b;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    padding: 0.5rem 1rem;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s ease;\r\n    margin-top: 0.5rem;\r\n    \r\n    &:hover:not(:disabled) {\r\n      background: #d97706;\r\n      transform: translateY(-1px);\r\n    }\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\r\n    }\r\n  }\r\n}\r\n\r\n.smtp-info {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background: #eff6ff;\r\n  border: 1px solid #dbeafe;\r\n  border-radius: 8px;\r\n\r\n  .info-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    margin-bottom: 0.75rem;\r\n    color: #3b82f6;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .info-content {\r\n    font-size: 0.75rem;\r\n    color: #6b7280;\r\n\r\n    .info-item {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding: 0.25rem 0;\r\n\r\n      .label {\r\n        font-weight: 500;\r\n        color: #374151;\r\n      }\r\n\r\n      .value {\r\n        color: #3b82f6;\r\n        background: rgba(59, 130, 246, 0.1);\r\n        padding: 0.125rem 0.375rem;\r\n        border-radius: 4px;\r\n        font-size: 0.6875rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #e2e8f0;\r\n  \r\n  .cancel-btn {\r\n    background: #f1f1f1;\r\n    color: #475569;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    \r\n    &:hover {\r\n      background: #e2e8f0;\r\n    }\r\n  }\r\n  \r\n  .save-btn {\r\n    background: #004A9A;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    \r\n    &:hover:not(:disabled) {\r\n      background: #003a7a;\r\n    }\r\n    \r\n    &:disabled {\r\n      background: #c4c4c4;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n}\r\n\r\n// Modal Styles - Match InvoiceSettings\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.75);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.modal {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  max-width: 600px;\r\n  width: 95%;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n  overflow: hidden;\r\n\r\n  &.email-config-modal {\r\n    max-width: 800px;\r\n  }\r\n\r\n  &.password-modal {\r\n    max-width: 500px;\r\n  }\r\n\r\n  .modal-header {\r\n    padding: 1.5rem 1.5rem 1rem 1.5rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #e2e8f0;\r\n\r\n    h4 {\r\n      font-size: 1.25rem;\r\n      font-weight: 600;\r\n      color: #004A9A;\r\n      margin: 0;\r\n    }\r\n\r\n    .close-btn {\r\n      border: none;\r\n      background: none;\r\n      cursor: pointer;\r\n      padding: 0.5rem;\r\n      border-radius: 6px;\r\n      color: #6b7280;\r\n      transition: all 0.2s ease;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n        color: #374151;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n    }\r\n  }\r\n\r\n  .modal-body {\r\n    padding: 1.5rem;\r\n    flex: 1;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .modal-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 1rem;\r\n    padding: 1rem 1.5rem 1.5rem 1.5rem;\r\n    border-top: 1px solid #e2e8f0;\r\n\r\n    .cancel-btn {\r\n      background: #f1f1f1;\r\n      color: #475569;\r\n      border: 1px solid #e0e0e0;\r\n      border-radius: 6px;\r\n      padding: 0.75rem 1.25rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.2s;\r\n      display: flex;\r\n      \r\n      &:hover {\r\n        background: #e2e8f0;\r\n      }\r\n    }\r\n    \r\n    .save-btn {\r\n      background: #004A9A;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 6px;\r\n      padding: 0.75rem 1.25rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: background-color 0.2s;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      \r\n      &:hover:not(:disabled) {\r\n        background: #003a7a;\r\n      }\r\n      \r\n      &:disabled {\r\n        background: #c4c4c4;\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Step info styles for password change modal\r\n.step-info {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n  background: #eff6ff;\r\n  border: 1px solid #bfdbfe;\r\n  border-radius: 8px;\r\n  margin-bottom: 1.5rem;\r\n  \r\n  svg {\r\n    flex-shrink: 0;\r\n    margin-top: 0.125rem;\r\n    color: #3b82f6;\r\n  }\r\n  \r\n  p {\r\n    margin: 0;\r\n    color: #1e40af;\r\n    font-size: 0.95rem;\r\n    line-height: 1.5;\r\n  }\r\n  \r\n  &.success {\r\n    background: #f0fdf4;\r\n    border-color: #bbf7d0;\r\n    \r\n    svg {\r\n      color: #16a34a;\r\n    }\r\n    \r\n    p {\r\n      color: #166534;\r\n    }\r\n  }\r\n}\r\n\r\n// Password mismatch error\r\n.password-mismatch-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.75rem 1rem;\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 6px;\r\n  margin-top: 1rem;\r\n  color: #dc2626;\r\n  font-size: 0.9rem;\r\n  \r\n  svg {\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n// Responsive adjustments\r\n@media (max-width: 768px) {\r\n  .email-config-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .form-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: column;\r\n    \r\n    .cancel-btn,\r\n    .save-btn {\r\n      width: 100%;\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .modal {\r\n    margin: 1rem;\r\n    width: calc(100% - 2rem);\r\n  }\r\n\r\n  .settings-card {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .step-info {\r\n    font-size: 0.9rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
